import React from 'react'

const SvgSort = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.707 8.707a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0l5.002 5.001a1 1 0 01-1.415 1.414L12 4.414 7.707 8.707zM16.294 15.294a1 1 0 011.415 1.415l-5 5a1 1 0 01-1.415 0l-5.001-5.002a1 1 0 111.414-1.414l4.294 4.294 4.293-4.293z'
    />
  </svg>
)

export default SvgSort
